import { Chip } from "@material-ui/core";
import React from "react";

export const StoragePlaceChip = ({ storagePlace, pallet, storageUrl }) => {
	if (!storagePlace) {
		return null;
	}

	return (
		<a
			href={storageUrl}
			target="_blank"
			rel="noopener noreferrer"
			style={{ textDecoration: "none" }}
		>
			<Chip
				size="small"
				label={storagePlace.address}
				variant={pallet.is_storage_place_confirmed ? "default" : "outlined"}
				style={
					pallet.into_preparation_place
						? { backgroundColor: "#c9a227", color: "white", cursor: "pointer" }
						: pallet.is_storage_place_confirmed
						? { backgroundColor: "#196d089f", color: "white", cursor: "pointer" }
						: { cursor: "pointer" }
				}
				clickable
			/>
		</a>
	);
};
